import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
} from "@/components/ui";
import { MappingStatusBadge } from "@/components/catalog";
import type { MappingReviewPendingCardProps } from "./MappingReviewPendingCard.types";

export const MappingReviewPendingCard: React.FC<
  MappingReviewPendingCardProps
> = ({ mappings, hasPending, onMapNow }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Pending Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {mappings.map((mapping) => (
            <div
              key={mapping.id}
              className="flex items-center justify-between p-2 rounded-lg bg-slate-50 dark:bg-slate-800/50"
            >
              <div className="flex items-center gap-3">
                <MappingStatusBadge status={mapping.status} />
                <div>
                  <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                    {mapping.displayName}
                  </p>
                  <p className="text-[10px] text-slate-500 dark:text-slate-400">
                    {mapping.marketplace}
                  </p>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="h-7 text-[10px]"
                onClick={() => onMapNow(mapping)}
              >
                Map Now
              </Button>
            </div>
          ))}
          {!hasPending && (
            <p className="text-sm text-slate-500 dark:text-slate-400 text-center py-4">
              No pending actions
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
